import React from "react";
import { Button } from "@/components/ui/button";
import { Calculator, ArrowRight } from "lucide-react";
import { useDemoPopup } from "@/pages/LandingPage";
import { useROICalculator } from "@/hooks/useROICalculator";
import { ROIInputForm } from "./roi/ROIInputForm";
import { ROIResultsPanel } from "./roi/ROIResultsPanel";

export const ROICalculator = () => {
  const { openDemoPopup } = useDemoPopup();
  const {
    inputs,
    results,
    hasCalculated,
    isLoadingPrice,
    handleInputChange,
    calculateROI,
    getInterpretation,
  } = useROICalculator();

  return (
    <section id="calculator" className="py-14 lg:py-28 bg-slate-50 blueprint-bg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12 lg:mb-16">
            <p className="section-label text-primary mb-4">
              <Calculator className="w-4 h-4 inline mr-2" />
              Calculateur ROI
            </p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 mb-4 tracking-tight">
              Combien perdez-vous <span className="text-accent">chaque mois</span> ?
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed max-w-3xl mx-auto">
              Decouvrez en quelques secondes combien d'urgences rentables vous echappent et quel chiffre d'affaires vous pourriez recuperer.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-6 lg:gap-8">
            <ROIInputForm
              inputs={inputs}
              isLoadingPrice={isLoadingPrice}
              onInputChange={handleInputChange}
              onCalculate={calculateROI}
            />
            <ROIResultsPanel results={results} />
          </div>

          {/* Interpretation */}
          {hasCalculated && results && (
            <div className="mt-8 bg-white border-2 border-primary/20 rounded-md p-6 lg:p-8" style={{ boxShadow: "4px 4px 0px rgba(30, 90, 158, 0.1)" }}>
              <h3 className="text-xl font-bold text-slate-900 mb-4" style={{ fontFamily: "Barlow, sans-serif" }}>
                Analyse de votre situation
              </h3>
              <p className="text-slate-600 leading-relaxed mb-6">{getInterpretation()}</p>
              <div className="border-t border-slate-200 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
                <p className="text-base font-semibold text-slate-900">Pret a recuperer ces urgences rentables ?</p>
                <Button
                  onClick={openDemoPopup}
                  data-testid="roi-cta-button"
                  className="bg-accent hover:bg-orange-600 text-white shadow-lg font-bold transition-all hover:scale-105 rounded-md px-6"
                >
                  Discuter de mon projet
                  <ArrowRight className="ml-2 w-5 h-5" />
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ROICalculator;
